export default "__VITE_ASSET__Cjn4$X9E__"